"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Duration = _interopRequireDefault(require("web/shared/telemetry/components/Duration"));
var _MetricsTableStyles = require("web/shared/telemetry/overview/MetricsTable.styles.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One metric's row: what it recorded over the window, or a plain statement
* that it recorded nothing.
*
* A metric that recorded nothing is still listed, because one that silently
* stopped recording looks exactly like one nobody calls from a list that
* omits both.
*/
function formatCount(count) {
  return count.toLocaleString();
}
function MetricRow(_ref) {
  let metric = _ref.metric; // Nothing at all in the window is worth saying once, plainly, rather than as
  // a row of dashes the reader has to interpret.
  const isEmpty = metric.estimatedCount === 0 && metric.inFlight === 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.cell, _perfTablesStyles.styles.dividedCell)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
        to: "/internal/perf/".concat(encodeURIComponent(metric.key))
      }, stylex.props(_MetricsTableStyles.styles.metricLink)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.prose)), {}, {
          children: metric.displayName
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.mono, _perfViewsStyles.styles.muted)), {}, {
          children: metric.key
        }))]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_MetricsTableStyles.styles.metricMeaning)), {}, {
        children: metric.description
      }))]
    })), isEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.cell, _perfViewsStyles.styles.muted, _perfTablesStyles.styles.dividedCell)), {}, {
      colSpan: 5,
      children: "nothing recorded in this window"
    })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
        children: formatCount(metric.estimatedCount)
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
          ms: metric.p50Ms
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
          ms: metric.p95Ms
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
          ms: metric.meanMs
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
        children: metric.inFlight > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.pill, _perfViewsStyles.styles.pillRunning)), {}, {
          children: formatCount(metric.inFlight)
        })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
          children: "0"
        }))
      }))]
    })]
  });
}
var _default = exports.default = MetricRow;